<template>
  <Adminlte>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="box box-primary center-block">
          <div class="box-header with-border">
            <h3 class="box-title">Editar Empresa {{this.company.name}}</h3>
          </div>
          <CompanyForm :company="company" :errors="errors" :onSubmit="onSubmit"></CompanyForm>
        </div>
      </div>
    </div>
  </Adminlte>
</template>
<script>
import Adminlte from '@/components/template/Adminlte'
import CompanyClient from '@/services/resource_client/company'
import CompanyForm from '@/pages/companies/CompanyForm'

export default {
  name: 'EditCompany',
  components: { Adminlte, CompanyForm },
  data: function () {
    return {
      company: {},
      errors: {}
    }
  },
  props: ['id'],
  methods: {
    onSubmit () {
      CompanyClient.put(this.company)
      .then(r => { this.$router.push({ name: 'CompaniesHome', params: { parkId: this.company._links['ea:park'].id } }) })
      .catch(e => { this.errors = e.response.data.errors })
    }
  },
  created () {
    CompanyClient.get(this.id)
    .then(r => {
      this.company = r.data
    })
  }
}
</script>



// WEBPACK FOOTER //
// EditCompany.vue?711f5f4d